import React from 'react';

const LunchInfo = ({ provider, price, paymentMethod, ordering, cancellation }) => {
  return (
    <>
      <p>Obědy jsou do školní výdejny přiváženy ze {provider}.</p>
      <p>Platby za obědy: {price}</p>
      {paymentMethod && <p>{paymentMethod}</p>}
      {ordering && <p>{ordering}</p>}
      {cancellation && <p>{cancellation}</p>}
    </>
  );
};

export default LunchInfo;
